import { IoStarOutline, IoStarSharp } from "react-icons/io5";
import Image from "next/image";

const Review = ({ data }) => {
  return data && (
    <>
      {data?.map((item, index) => (      
        <div
          key={index}
          style={{ marginBottom: "20px" }}
          className="lg:w-9/12 md:m-auto mt-5 p-3  rounded-xl shadow-sm shadow-cyan-500/50 "
        >
          <a href={`#review${index}`} id={`review${index}`}>
          <div className="flex justify-between">
            <div className="flex">
              <div className=" overflow-hidden flex  justify-center  w-24 h-24 rounded-full mx-auto">
                {item.user?.image ? (
                  <img
                    className="w-10 h-10 rounded-full mx-auto"
                    height={`100px`}
                    width={`100px`}
                    src={item.user.image}
                    alt="user image"
                  />
                ) : (
                  <div className="bg-green-500 p-2 text-center h-12 w-12 rounded-full">
                    <div className="text-white text-2xl font-bold">
                      {/* <div className="leading-none font-bold align-center pl-1 font-serif block"> */}
                      {item.user?.name[0] ? item.user?.name[0] : "A"}
                      {/* </div> */}
                    </div>
                  </div>
                )}
              </div>
              <div className="pt-1.3">
                <p className="font-medium">{item.user?.name}</p>
                <div className="flex flex-wrap mt-1 mb-1">
                  <div className="flex mt-0.1">
                    {[...Array(5)].map((star, indexStar) => {
                      return (
                        <div key={indexStar} className="mt-0.5">
                          <div className="hidden">{star}</div>
                          {item.rating > indexStar ? (
                            <IoStarSharp />
                          ) : (
                            <IoStarOutline />
                          )}
                        </div>
                      );
                    })}
                  </div>
                  
                </div>
              </div>
            </div>

            <div className="flex self-end w-2/5 sm:1/5 ">
              <p className="text-sm mb-16 text-gray-600 sm:pl-5 lg:pr-10 xl:pr-0 text-right w-full">
                {new Date(item.createdAt).toLocaleDateString("en-us", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })}
              </p>
            </div>
          </div>
          </a>

          <div className="flex flex-wrap mt-2 mb-2 w-full">
            <p className="text-l md:font-medium text-gray-800 text-base pb-5 w-full pl-5">
              {item.text}
            </p>

            {item.attachment.length > 0 && (
              <div className="container grid sm:grid-cols-2 md:grid-cols-3 gap-4 mx-auto place-items-center place-content-center" >
                {item.attachment?.map((image, imageIndex) => (
                  <Image
                    key={imageIndex}
                    src={image}
                    alt="Review image"
                    width={450}
                    height={450}
                    className="rounded-xl lg:w-full object-contain"
                    loading="lazy"
                    placeholder="blur"
                    blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                    style={{
                      maxWidth: "100%",
                      height: "auto"
                    }} />
                ))}
              </div>
            )}
          </div>
        </div>       
      ))}
    </>
  );
};
export default Review;
